import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddCategories from "./ManagePhotosCategories/Create.js"
import Categories from "./ManagePhotosCategories/View.js"

import AddSuggestedCategories from "./SuggestedCategories/Create.js"
import SuggestedCategories from "./SuggestedCategories/View.js"

import AddViewAllPhotos from "./ViewAllPhotos/Create.js"
import ViewAllPhotos from "./ViewAllPhotos/View.js"

import AddSynonymList from "./SynonymList/Create.js"
import SynonymList from "./SynonymList/View.js"

import ProtectedRoute from "../RouteProtect.js"

const CarrierCardArray = [
    {
        title: "Manage Photos Categories",
        path: "managePhotosCategories",
        auth: "carrier",
    },
    {
        title: "Suggested Categories",
        path: "suggestedCategories",
        auth: "carrier",
    },
    {
        title: "Synonym List",
        path: "synonymList",
        auth: "carrier",
    },
    {
        title: "View All Photos",
        path: "viewAllPhotos",
        auth: "carrier",
    },
]


const RoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...CarrierCardArray]} />
    },
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "managePhotosCategories/*",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <Categories />
                </ProtectedRoute>
            )
    },
    {
        path: "managePhotosCategories/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "managePhotosCategories/addcategorie",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddCategories />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedCategories/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <SuggestedCategories />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedCategories/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "suggestedCategories/addSuggestedCategories",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddSuggestedCategories />
            </ProtectedRoute>
        )
    },
    {
        path: "viewAllPhotos/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <ViewAllPhotos />
            </ProtectedRoute>
        )
    },
    {
        path: "viewAllPhotos/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "viewAllPhotos/addViewAllPhotos",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <AddViewAllPhotos />
            </ProtectedRoute>
        )
    },
    // {
    //     path: "synonymList/*",
    //     element: (
    //         <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
    //             <SynonymList />
    //         </ProtectedRoute>
    //     )
    // },
    // {
    //     path: "synonymList/:id",
    //     element: (
    //         <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
    //             <EditFormRoute />
    //         </ProtectedRoute>
    //     )
    // },
    // {
    //     path: "synonymList/addsynonymList",
    //     element: (
    //         <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
    //             <AddSynonymList />
    //         </ProtectedRoute>
    //     )
    // },
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};